/* eslint-disable camelcase */
import api from '@pray/shared/utils/api';
import { ObjectResponse } from '@pray/shared/utils/api/types/response';

type ValidateArtistDomainProps = {
  artistId: string;
  sendgridDomainId: string;
  type: 'branding' | 'email';
};

type ValidateArtistDomainResponse = {
  id: number;
  valid: boolean;
  validation_results: {
    mail_cname: {
      valid: boolean;
      reason: string;
    };
    dkim1: {
      valid: boolean;
      reason: string;
    };
    dkim2: {
      valid: boolean;
      reason: string;
    };
  };
};

export const validateArtistDomain = async ({
  artistId,
  sendgridDomainId,
  type = 'email',
}: ValidateArtistDomainProps) => {
  if (!artistId) throw Error('Artist ID is required');
  if (!sendgridDomainId) throw Error('Sendgrid Domain ID is required');

  const url = `/web/studio/artists/${artistId}/emails/domains/validate`;

  const response = await api.executePostRequest<ObjectResponse<ValidateArtistDomainResponse>>(url, {
    sendgrid_domain_id: parseInt(sendgridDomainId, 10),
    type,
  });

  return response.data;
};
